<script>

    export default {
        data () {
            return {
                visibleModal: ''
            }
        },
        props: {
        },
        mounted () {
            let slug = location.hash.replace('#', '')
            if (slug.length) {
                this.visibleModal = slug
            }
        },
        methods: {
            setVisibleModal(slug){
              this.visibleModal = slug
              location.hash = slug
            },
            modalVisible(slug) {
                return this.visibleModal == slug
            },
            closeModal() {
                this.visibleModal = ''
                // If this string is left empty, it scrolls the user
                // back to the top of the page, which is unwanted. So,
                // setting it to anything other than a leadership name
                // seems to do the trick.
                location.hash = 'modalclosed'
            }
        }
    }
</script>
